export const ListCardActionsEnum = {
  Download: { val: 0, name: 'Download part list' },
  Rename: { val: 1, name: 'Rename part list' },
  Share: { val: 2, name: 'Share part list' },
  Delete: { val: 3, name: 'Delete part list' },
};
